import api from './api';

export const getWeather = async () => {
  const response = await api.get('/weather');
  return response.data;
};
